class campaign{
	constructor(campaigns){
		this.campaigns=campaigns
	}
	renderCampaigns(){
		this.campaigns.forEach((campaign, index, arr)=>{
            var campaginLink;

            switch (campaign.name) {
                case "Create Account":
                    campaginLink = $("<a>").attr("href", "/account/register")
                    break;
                case "Points for Purchases":
                    campaginLink = $("<a>").attr("href", "/collections/all")
                    break;
                case "Happy Birthday":
                    campaginLink = $("<a>").attr("href", "/account/login")
                    break;
                case "Referral Program":
                    campaginLink = $("<a>").attr("href", "#referral-friend")
                    break;
                case "Read Content":
                    campaginLink = $("<a>").attr("href", "/pages/smart-cups-technology")
                    break;
                case "Page Visit":
                    campaginLink = $("<a>").attr({
                        href: "https://www.facebook.com/SmartCupsTM/",
                        target: "_blank"
                    })
                    break;
                case "Instagram Follow":
                    campaginLink = $("<a>").attr({
                        href: "https://www.instagram.com/smartcups/",
                        target: "_blank"
                    })
                    break;
                default:
                    break;
            }

            $(".campaigns-option").append(
                $("<div>").append(
                    $("<img>").addClass(`campaign${++index}`),
                    $("<h4>").text(campaign.title),
                    $("<p>").text(campaign.reward_text),
                    campaginLink
                    )
                )

            if (arr.length === index) {
				$(".campaigns-option").append(
                $("<div>").append(
                    $("<img>").addClass("campaign1"),
                    $("<h4>").text("And more"),
                    $("<p>").html("&nbsp;"),
                    $("<a>").attr("href", "/pages/rewards")
                    )
                )
			}
	
		})
	}
                               
    loggedInHandlerIn(campaign){
      	if(swellAPI.getCustomerDetails().created_at === undefined) {
			$(`.logged-out-campaign-${campaign.id}`).css("display", "flex");
      	}
    }
      
    loggedInHandlerOut(campaign){
      	if(swellAPI.getCustomerDetails().created_at === undefined) {
       		$(`.logged-out-campaign-${campaign.id}`).css("display", "none"); 
      	}
    }
}